// extracted by mini-css-extract-plugin
export default {"filters":"styles_filters__xXtHg","filtersBox":"styles_filtersBox__0CFNJ","tables":"styles_tables__xEcjl","tableSection":"styles_tableSection__3XGGK"};